/* Facebook Pixel carregado sob demanda, apenas pelas páginas que o utilizam.
   Fica fora do public/index.html de propósito, para não afetar as demais rotas. */

export const FACEBOOK_PIXEL_ID = "1019731787769164";

const FBEVENTS_SRC = "https://connect.facebook.net/en_US/fbevents.js";

let initializedPixelId = null;

function ensureFbq() {
  if (typeof window === "undefined") return null;
  if (window.fbq) return window.fbq;

  const fbq = function fbqStub(...args) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
      return;
    }
    fbq.queue.push(args);
  };

  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = FBEVENTS_SRC;
  document.head.appendChild(script);

  return fbq;
}

export function initFacebookPixel(pixelId = FACEBOOK_PIXEL_ID) {
  if (initializedPixelId === pixelId) return;

  const fbq = ensureFbq();
  if (!fbq) return;

  fbq("init", pixelId);
  fbq("track", "PageView");
  initializedPixelId = pixelId;
}

export function trackPixelEvent(eventName, params) {
  if (typeof window === "undefined" || !window.fbq) return;
  window.fbq("trackCustom", eventName, params);
}

function readCookie(name) {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : null;
}

/* Rede de segurança: o Pixel grava o _fbc sozinho quando vê o fbclid na URL.
   Se o cookie tiver sumido no caminho até o formulário, reescrevemos no formato
   documentado pela Meta (fb.1.<timestamp>.<fbclid>) para não perder o clique. */
export function ensureClickIdCookie(fbclid, clickTimestamp) {
  if (typeof document === "undefined" || !fbclid) return;
  if (readCookie("_fbc")) return;

  const value = `fb.1.${clickTimestamp || Date.now()}.${fbclid}`;
  const maxAge = 90 * 24 * 60 * 60;
  document.cookie = `_fbc=${value};path=/;max-age=${maxAge};SameSite=Lax`;
}

const LEAD_STORAGE_KEY = "ginastee:apply-lead-event-id";

function createEventId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `lead-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

/* Dispara o Lead uma única vez por sessão, para que um refresh ou um voltar
   no navegador não infle a contagem de conversões. Devolve o eventID usado,
   que serve de chave de deduplicação caso a API de Conversões entre depois. */
export function trackLeadOnce(params) {
  if (typeof window === "undefined" || !window.fbq) return null;

  let eventId = null;
  let alreadyFired = false;

  try {
    eventId = window.sessionStorage.getItem(LEAD_STORAGE_KEY);
    alreadyFired = Boolean(eventId);
  } catch (error) {
    /* storage indisponível: seguimos e disparamos o evento */
  }

  if (alreadyFired) return eventId;

  eventId = createEventId();

  try {
    window.sessionStorage.setItem(LEAD_STORAGE_KEY, eventId);
  } catch (error) {
    /* idem */
  }

  window.fbq("track", "Lead", params, { eventID: eventId });
  return eventId;
}
